/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';

const VIsmallcard = (props) => {
    const { className } = props;
    return (
        <SvgIcon className={className} viewBox="0 0 36 24">
            <g
                id="smallcard_visa"
                fillRule="evenodd"
                clipRule="evenodd"
            >
                <rect x="0.947937" y="1.34918" width="35" height="22" rx="3.5" fill="white" stroke="#D9D9D9" />
                <path d="M11.3768 16.43H9.1959L7.56049 10.6169C7.48287 10.3495 7.31805 10.1131 7.07561 10.0016C6.47057 9.72164 5.80386 9.49881 5.07654 9.38642V9.16261H8.5898C9.07468 9.16261 9.43834 9.49881 9.49895 9.88925L10.3475 14.0825L12.5273 9.16261H14.6476L11.3768 16.43ZM15.8598 16.43H13.8001L15.4962 9.16261H17.5558L15.8598 16.43ZM20.2206 11.1759C20.2812 10.7845 20.6448 10.5607 21.0691 10.5607C21.7358 10.5045 22.4621 10.6169 23.0682 10.8959L23.4318 9.3312C22.8257 9.1074 22.159 8.99501 21.554 8.99501C19.5549 8.99501 18.1003 10.0017 18.1003 11.3987C18.1003 12.4616 19.1306 13.0196 19.858 13.3558C20.6448 13.6911 20.9479 13.9149 20.8873 14.2501C20.8873 14.7529 20.2812 14.9767 19.6761 14.9767C18.9488 14.9767 18.2215 14.8091 17.5558 14.5291L17.1922 16.0948C17.9195 16.3738 18.7064 16.4862 19.4337 16.4862C21.6752 16.5414 23.0682 15.5357 23.0682 14.0263C23.0682 12.1254 20.2206 12.014 20.2206 11.1759ZM30.2765 16.43L28.6411 9.16261H26.8845C26.5208 9.16261 26.1572 9.38642 26.036 9.72164L23.0076 16.43H25.1279L25.5511 15.3681H28.1562L28.3987 16.43H30.2765ZM27.1876 11.1197L27.7926 13.8587H26.0966L27.1876 11.1197Z" fill="#172B85" />
            </g>
        </SvgIcon>
    );
};

VIsmallcard.defaultProps = { className: '' };

VIsmallcard.propTypes = { className: PropTypes.string };

export default VIsmallcard;
